module.exports = __webpack_public_path__ + "img/制御工学3_1_5.317f010a.png";